import {
  SIGN_IN,
  SIGN_OUT,
  RELOAD_TOKEN,
  LOAD_CDX_USER,
  UPDATE_USER_SETTING,
  GET_WALLET_BALANCE,
  GET_WALLET_DETAIL,
  WALLET_DETAIL_HASH,
} from "actions/types";

import CodexAPI from "app/api/codexapi";
import { deploySnackbar } from "actions";
import { codexApiCatchError } from "actions/snackBar";

import encrypt from "app/utils/encrypt";
import decryptToObject from "app/utils/decryptToObject";
import changeLanguage from "app/utils/changeLanguage";

import {
  LSK_CDX_USER_INFO_HASH,
  LSK_CDX_IS_EMAIL_SIGNIN,
  LSK_CDX_ACTIVE_SHEET,
} from "settings/localStorageKeys";

import checkObjectEqual from "app/utils/checkObjectEqual";

import { apiServerError } from "actions/snackBar";

export const signIn = (fbData) => {
  return {
    type: SIGN_IN,
    payload: {
      user: {
        uid: fbData.uid,
        email: fbData.email,
        fbData,
        token: fbData.accessToken,
        tokenExpireAt: fbData.stsTokenManager.expirationTime,
      },
    },
  };
};

export const signOut = () => {
  window.localStorage.removeItem(LSK_CDX_ACTIVE_SHEET);
  return {
    type: SIGN_OUT,
  };
};

export const reloadToken = (fbData) => {
  const email = fbData.email;

  let emailSignIn = window.localStorage.getItem(LSK_CDX_IS_EMAIL_SIGNIN);

  try {
    emailSignIn = decryptToObject(emailSignIn);
  } catch {
    emailSignIn = {};
  }

  if (emailSignIn.email === email) {
    emailSignIn = emailSignIn.isEmailSignIn;
  } else {
    emailSignIn = false;
  }
  
  return {
    type: RELOAD_TOKEN,
    payload: {
      app: { isEmailSignIn: emailSignIn },
      user: {
        uid: fbData.uid,
        email: fbData.email,
        fbData,
        token: fbData.accessToken,
        tokenExpireAt: fbData.stsTokenManager.expirationTime,
      },
    },
  };
};

export const loadCdxUser = () => async (dispatch, getState) => {
  const email = getState().user.email || "noemail";
  let dataHash = window.localStorage.getItem(LSK_CDX_USER_INFO_HASH);

  const dispatchLoadCdxUser = (data) => {
    dispatch({ type: LOAD_CDX_USER, payload: { ...data } });
  };

  try {
    dataHash = decryptToObject(dataHash);
  } catch {
    dataHash = {};
  }
  if (dataHash.email === email) {
    try {
      const result = await CodexAPI().get("/user/info/", {
        params: { hash: dataHash.hash },
      });
      dispatchLoadCdxUser(result.data.data);
      if (result.data.data.userSetting) {
        changeLanguage(result.data.data.userSetting.language);
      }
    } catch (error) {
      dispatch(codexApiCatchError(error));
    }
  }

  try {
    const hashResult = await CodexAPI().get("/user/info/hash/");
    const hash = hashResult.data.data;
    if (dataHash.hash !== hash) {
      const result = await CodexAPI().get("/user/info/", {
        params: { hash: hash },
      });
      dispatchLoadCdxUser(result.data.data);
      if (result.data.data.userSetting) {
        changeLanguage(result.data.data.userSetting.language);
      }
      window.localStorage.setItem(
        LSK_CDX_USER_INFO_HASH,
        encrypt({ email: email, hash: hash })
      );
    }
  } catch (error) {
    dispatch(codexApiCatchError(error));
  }
};

export const updateUserSetting = (setting) => (dispatch, getState) => {
  if (checkObjectEqual(setting, getState().user.userSetting || {})) {
    return;
  }

  try {
    const response = CodexAPI().post("user/update-setting/", setting);
    const snackBar = {
      color: "success",
      icon: "done",
      title: "Successfully update setting",
      content: `Your setting has been updated.`,
    };
    dispatch(deploySnackbar(snackBar));
    if (setting.language) {
      changeLanguage(setting.language);
    }
    dispatch({
      type: UPDATE_USER_SETTING,
      payload: setting,
    });
  } catch (error) {
    dispatch(codexApiCatchError(error));
  }
};

export const getWalletBalance = () => async (dispatch, getState) => {
  try {
    const response = await CodexAPI().get("/user/wallet/balance/");
    dispatch({ type: GET_WALLET_BALANCE, payload: response.data.data });
  } catch (error) {
    dispatch(codexApiCatchError(error));
  }
};

export const getWalletDetail = () => async (dispatch, getState) => {
  const prevHash = getState().hashDictionary[WALLET_DETAIL_HASH];
  try {
    let response = await CodexAPI().get("/user/wallet/detail/hash/");
    const newHash = response.data.data;
    if (prevHash !== newHash) {
      response = await CodexAPI().get("/user/wallet/detail/", {
        params: { hash: newHash },
      });
      dispatch({
        type: WALLET_DETAIL_HASH,
        payload: newHash,
      });
      dispatch({ type: GET_WALLET_DETAIL, payload: response.data.data });
    }
  } catch (error) {
    if (!error.response) {
      dispatch(apiServerError());
    }
  }
};
